export const getCurrentMonthYear = () => {
  const now = new Date();
  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  return `${monthNames[now.getMonth()]} ${now.getFullYear()}`;
};
